module.exports = __webpack_public_path__ + "static/img/淡色优雅背景-翻转.ec2d582.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/淡色优雅背景-翻转.png
// module id = tLLJ
// module chunks = 1